<div class="modal-header">
  <h4 style="padding-right: 4px;" class="modal-title">Enter 4-digit Code</h4>
  <button style="margin-right:4px;" type="button" class="close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i style="font-size:16px;" class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <div class="modal-body-inner">
    <h4 class="text-center">Two Factor Authentication</h4>

    <p class="text-center">Enter 4-digit code sent on {{phone}}.</p>
    <div>
      <table class="text-center table-sixty">
        <tbody>
          <tr>
            <td class="td-sixty">
              <input [ngClass]="isValid ? '' : 'isinvalid'" class="form-control large-box input-lg text-center"
                type="text" (keyup)="onKeyUp($event,'0')" (keydown.backspace)="onBackSpace('0')" #codeCtrl1
                maxlength="1" pattern="[\d]*" tabindex="1" placeholder="." autocomplete="off" [value]="code1"
                (input)="code1 = $event.target.value" />
            </td>
            <td class="td-sixty">
              <input (keyup)="onKeyUp($event,'1')" [ngClass]="isValid ? '' : 'isinvalid'"
                class="form-control large-box input-lg" type="text" #codeCtrl2 (keydown.backspace)="onBackSpace('1')"
                maxlength="1" pattern="[\d]*" tabindex="2" placeholder="." autocomplete="off" [value]="code2"
                (input)="code2 = $event.target.value" />
            </td>
            <td class="td-sixty">
              <input (keyup)="onKeyUp($event,'2')" [ngClass]="isValid ? '' : 'isinvalid'"
                class="form-control large-box input-lg" type="text" #codeCtrl3 (keydown.backspace)="onBackSpace('2')"
                maxlength="1" pattern="[\d]*" tabindex="3" placeholder="." autocomplete="off" [value]="code3"
                (input)="code3 = $event.target.value" />
            </td>
            <td class="td-sixty">
              <input (keyup)="onKeyUp($event,'3')" [ngClass]="isValid ? '' : 'isinvalid'"
                class="form-control large-box input-lg" type="text" #codeCtrl4 (keydown.backspace)="onBackSpace('3')"
                maxlength="1" pattern="[\d]*" tabindex="4" placeholder="." autocomplete="off" [value]="code4"
                (input)="code4 = $event.target.value" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" (click)="checkCode()" class="btn btn-success btn-block">Continue</button>

  <p style="display:block;width:100%;text-align: center;" *ngIf="isCodeMismatch" class="error">Entered code doesn't
    match.</p>
</div>
